import { SideNavCategory } from '@@types/sideNav';

export const adminNavData: SideNavCategory[] = [
  {
    category: '홈',
    items: [
      {
        name: '주점 대시보드',
        path: '',
      },
    ],
  },
  {
    category: '실시간',
    items: [
      {
        name: '실시간 주문 조회',
        path: '/order/realtime',
      },
      {
        name: '실시간 테이블 관리',
        path: '/table/realtime',
      },
    ],
  },
  {
    category: '주문',
    items: [
      {
        name: '주문 타임라인 조회',
        path: '/order-timeline',
      },
      {
        name: '전체 주문 조회',
        path: '/total-order',
      },
      {
        name: '주문 통계',
        path: '/order/statistics',
      },
    ],
  },
  {
    category: '상품',
    items: [
      {
        name: '상품 관리',
        path: '/products',
      },
      {
        name: '카테고리 관리',
        path: '/products/categories',
      },
    ],
  },
  {
    category: '설정',
    items: [
      {
        name: '주점 정보 관리',
        path: '/edit',
      },
    ],
  },
];
